export const editTicketModalSelectors = {
  container: 'edit-ticket-modal',
  submitButton: 'edit-ticket-modal-submit-button'
};
